import { useBrand } from '../lib/brand.ts';

/**
 * The ERP PRO mark: a three-face cube (one platform; data, modules and clients).
 * Colours come from the logo tokens; put it inside `.brand-logo` (navy tile) or
 * straight on the navy side navigation. The same geometry is in public/icon.svg,
 * public/favicon.svg, public/brand/*.svg and the Android launcher icon.
 */
export function BrandMark({ size = 24 }: { size?: number }) {
  // A partner's own logo (white-label) in its place.
  const brand = useBrand();
  if (brand?.logo) return <img className="brand-cube brand-img" src={brand.logo} width={size} height={size} alt="" />;
  return (
    <svg className="brand-cube" width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <polygon points="24,6.42 38.4,14.75 24,23.08 9.6,14.75" fill="var(--logo-top)" />
      <polygon points="8.8,16.14 23.2,24.46 23.2,41.11 8.8,32.79" fill="var(--logo-left)" />
      <polygon points="24.8,24.46 39.2,16.14 39.2,32.79 24.8,41.11" fill="var(--logo-right)" />
    </svg>
  );
}
